<template>
  <v-container>
    <v-row>
      <v-col class="noPaddingBtm" :cols="2">
        <ryou-select
          class="ryouSelectStyle"
          :label="'物件グループ名'"
          :items="buildGroupItems"
          :itemText="'build_group_name'"
          :itemValue="'build_group_id'"
          v-model="selectBuildGroupValue"
          :value="selectBuildGroupValue"
        >
        </ryou-select>
      </v-col>
      <v-col class="noPaddingBtm" :cols="2">
        <ryou-select
          class="ryouSelectStyle"
          :label="'物件名'"
          :items="buildingItems"
          :itemText="'building_name'"
          :itemValue="'building_id'"
          v-model="selectBuildingValue"
          :value="selectBuildingValue"
        >
        </ryou-select>
      </v-col>
      <v-col class="noPaddingBtm" :cols="2">
        <ryou-autocomplete
          class="ryouSelectStyle"
          :label="'寮生'"
          :items="userItems"
          :itemText="'user_name'"
          :itemValue="'user_id'"
          v-model="selectUserValue"
          :value="selectUserValue"
        >
        </ryou-autocomplete>
      </v-col>
      <v-col cols="2">
        <ryou-date-format
          ref="ryou_date_format"
          v-model="inputDate"
          :value="inputDate"
          :label="'対象年月'"
          :format="'$1/$2'"
        >
        </ryou-date-format>
      </v-col>
    </v-row>
    <v-card flat>
      <v-form
        ref="tableForm"
        v-model="tableForm"
        lazy-validation
        @submit.prevent
      >
        <ryou-table
          ref="ryouTable"
          :rowKey="rowKey"
          :headers="headers"
          :url="url"
          :businessKey="businessKey"
          :dummy="false"
          :height="height"
          :needSearch="true"
          :queryParams="queryParams"
          :handleEdit="handleEdit"
          :handleDelete="handleDelete"
        >
          <v-row slot="filterContainer">
            <v-col cols="4"></v-col>
            <v-col :cols="2">
              <!-- 2024.10.11 kouta.noborisaka .xlsxに変更 -->
              <v-file-input
                accept=".xlsx"
                label="ファイル選択"
                v-model="chosenFile"
                :rules="inputRulesFile"
                truncate-length="55"
              >
              </v-file-input>
            </v-col>
            <v-col cols="2" class="UserAddBtn">
              <ryou-black-btn
                :label="'ファイル入力'"
                :handlerClick="importFile"
                :iconCls="'mdi-file-upload'"
              >
              </ryou-black-btn>
            </v-col>
            <v-col cols="2" class="UserAddBtn">
              <ryou-blue-btn
                :label="'新規追加'"
                :handlerClick="handleAdd"
                :disabled="btnCtrl"
              >
              </ryou-blue-btn>
            </v-col>
          </v-row>
        </ryou-table>
      </v-form>
    </v-card>
    <other-claim-dialog
      ref="modalForm"
      @ok="modalFormOk"
      :url="url"
      :buildingId="selectBuildingValue"
      :buildingGroupId="selectBuildGroupValue"
    ></other-claim-dialog>
    <ryou-confirm ref="confirm"></ryou-confirm>
  </v-container>
</template>

<script>
import RyouTable from "@/components/table/RyouTable.vue";
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
import RyouSelect from "@/components/formInput/RyouSelect";
import RyouAutocomplete from "@/components/formInput/RyouAutocomplete";
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import OtherClaimDialog from "./modules/SalaryOtherClaimDialog.vue";
import RyouConfirm from "@/components/dialog/RyouConfirm.vue";

import { postUploadRequest } from "@/utils/api";

export default {
  name: "SalaryOtherClaimRegistration",
  mixins: [RyouTableMixins],
  components: {
    RyouTable,
    RyouDateFormat,
    RyouSelect,
    RyouAutocomplete,
    RyouBlueBtn,
    RyouBlackBtn,
    OtherClaimDialog,
    RyouConfirm,
  },
  data() {
    return {
      tableForm: true,
      rowKey: "rowIdex",
      businessKey: "billing_seq_no",
      height: 680,
      btnCtrl: true,
      chosenFile: null,
      headers: [
        {
          text: "",
          class: "blue lighten-2 title",
          value: "billing_seq_no",
          align: "start",
          width: "0.01%",
          sortable: false,
          groupable: false,
          type: "hidden",
        },
        {
          text: "物件名",
          class: "blue lighten-2 title",
          value: "building_name",
          align: "start",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "部屋番号",
          class: "blue lighten-2 title",
          value: "room_id",
          align: "start",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "ユーザID",
          class: "blue lighten-2 title",
          value: "user_id",
          align: "start",
          width: "8%",
          sortable: false,
          groupable: false,
        },
        {
          text: "ユーザ名",
          class: "blue lighten-2 title",
          value: "user_name",
          align: "start",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "課金区分",
          class: "blue lighten-2 title",
          value: "billing_class_name",
          align: "start",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "課金日",
          class: "blue lighten-2 title",
          value: "input_date_str",
          align: "start",
          width: "7%",
          sortable: true,
          groupable: false,
        },
        {
          text: "課金名称",
          class: "blue lighten-2 title",
          value: "billing_name",
          align: "start",
          width: "15%",
          sortable: true,
          groupable: false,
        },
        {
          text: "請求代",
          class: "blue lighten-2 title",
          value: "billing_fee",
          align: "start",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "",
          class: "blue lighten-2 title",
          value: "billing_class",
          align: "start",
          width: "0.01%",
          type: "hidden",
        },
        {
          text: "支払い",
          value: "button",
          type: "btn",
          width: "4%",
          sortable: false,
          groupable: false,
        },
        {
          text: "操作",
          class: "blue lighten-2 title",
          value: "actions",
          align: "center",
          sortable: false,
          groupable: false,
        },
      ],
      inputDate: "",
      selectBuildGroupValue: "",
      selectBuildingValue: "",
      selectUserValue: "",
      buildGroupItems: [],
      buildingItems: [],
      userItems: [],
      url: {
        list: "/otherClaimRegistration/otherClaimGet",
        userGet: "/otherClaimRegistration/userGet",
        buildGroupGet: "/otherClaimRegistration/buildGroupGet",
        buildingGet: "/otherClaimRegistration/buildingGet",
        billingClassGet: "/otherClaimRegistration/billingClassGet",
        insert: "/otherClaimRegistration/otherClaimInsert",
        update: "/otherClaimRegistration/otherClaimUpdate",
        delete: "/otherClaimRegistration/otherClaimDelete",
        btnUpdate: "/otherClaimRegistration/payClassUpdate",
        fileUpload: "/otherClaimRegistration/fileInsert?loginUserId=",
      },
      queryParams: {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
        billingMonth: "",
        buildGroupId: "",
        buildingId: "",
        targetUserId: "",
      },
      inputRulesFile: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.$refs.ryouTable.$on("doHandleBtn", this.doHandleBtn);
    this.inputRulesFile.push(this.GlobalRules.required);
  },
  watch: {
    selectBuildGroupValue(value) {
      //グループ選択時、他の選択項目をクリアする
      this.selectBuildingValue = "";
      this.selectUserValue = "";

      if (value != "") {
        let params = {
          buildGroupId: value,
        };
        //物件一覧を取得
        this.getRequest(
          this.url.buildingGet,
          params,
          this.$store.getters.getUserToken
        ).then((data) => {
          if (data.success) {
            var mapDatas = data.result.map((item) => {
              item.building_id = String(item.building_id);
              return item;
            });
            this.buildingItems = mapDatas;
            this.selectBuildingValue = mapDatas[0].building_id;
            // this.buildingItems.push(this.selectBuildingValue);
          }
        });

        //物件選択が空の場合はグループに紐づくユーザを取得する
        if (this.selectBuildingValue == "") {
          //selectBoxで値を取る
          this.getRequest(
            this.url.userGet,
            params,
            this.$store.getters.getUserToken
          ).then((data) => {
            if (data.success && data.status == "200") {
              var mapDatas = data.result.map((item) => {
                item.user_name = item.user_id + "　" + item.user_name;
                return item;
              });
              this.userItems = mapDatas;
            }
          });
        }
      } else {
        //物件グループを未選択にした際、他のリストをクリアする
        this.buildingItems = [];
        this.userItems = [];
      }

      //パラメータを更新し、DBよりデータを取得
      this.setQueryParms();
      this.$refs.ryouTable.loadData();
    },
    selectBuildingValue(value) {
      this.selectUserValue = "";

      let params;
      //物件が選択されている場合は物件で検索
      if (value != "" && value != null) {
        params = {
          buildGroupId: this.selectBuildGroupValue,
          buildingId: value,
        };
        this.btnCtrl = false;
        this.buildingId = value;
      } else {
        //物件が選択されていない場合はグループで検索
        params = {
          buildGroupId: this.selectBuildGroupValue,
        };
        this.btnCtrl = true;
        this.buildingId = "";
      }

      // 2024.11.25 kouta.noborisaka 三井化学（市原工場）:物件グループが空のときは処理しないように変更
      if (this.selectBuildGroupValue != "") {
        this.getRequest(
          this.url.userGet,
          params,
          this.$store.getters.getUserToken
        ).then((data) => {
          if (data.success && data.status == "200") {
            var mapDatas = data.result.map((item) => {
              item.user_name = item.user_id + "　" + item.user_name;
              return item;
            });
            this.userItems = mapDatas;
          }
        });
      }
      //パラメータを更新し、DBよりデータを取得
      this.setQueryParms();
      this.$refs.ryouTable.loadData();
    },

    selectUserValue(value) {
      if (value != "") {
        //パラメータを更新し、DBよりデータを取得
        this.setQueryParms();
        this.$refs.ryouTable.loadData();
      }
    },
    inputDate() {
      //パラメータを更新し、DBよりデータを取得
      this.setQueryParms();
      this.$refs.ryouTable.loadData();
    },
  },
  methods: {
    initData() {
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      //物件グループリストを取得
      this.getRequest(
        this.url.buildGroupGet,
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.buildGroupItems = data.result;

          //管理人の場合はグループを選択状態にする
          if (
            this.$store.getters.getUserClass == "2" ||
            this.$store.getters.getUserClass == "4" ||
            this.$store.getters.getUserClass == "5"
          ) {
            this.selectBuildGroupValue = this.buildGroupItems[0].build_group_id;
          } else if (this.$store.getters.getUserClass == "1") {
            this.buildGroupItems.push("");
          }
        }
      });
    },
    //データ取得のパラメータを設定する
    setQueryParms() {
      this.queryParams.inputDate = this.inputDate;
      this.queryParams.buildGroupId = this.selectBuildGroupValue;
      this.queryParams.buildingId = this.selectBuildingValue;
      this.queryParams.targetUserId = this.selectUserValue;
    },
    //支払い区分更新
    doHandleBtn(record) {
      let params = {
        updUserId: this.$store.getters.getUserId,
        billingSeqNo: record.billing_seq_no.toString(),
        payClass: record.pay_class,
      };
      this.putRequest(
        this.url.btnUpdate,
        params,
        this.$store.getters.getUserToken
      ).then((resp) => {
        if (resp.success) {
          //更新成功の場合DBよりデータを取得する
          this.$refs.ryouTable.loadData();
        }
      });
    },
    //xlsxファイル登録
    importFile() {
      var valid = this.$refs.tableForm.validate();
      if (valid) {
        let formData = new FormData();
        formData.append("file", this.chosenFile);
        var fileUrl =
          this.url.fileUpload +
          this.$store.getters.getUserId +
          "&userClass=" +
          this.$store.getters.getUserClass;
        postUploadRequest(
          fileUrl,
          formData,
          this.$store.getters.getUserToken
        ).then(async (resp) => {
          if (resp.success) {
            this.$refs.ryouTable.loadData();
            this.$refs.tableForm.reset();
          }
        });
      }
      setTimeout(() => {}, 100);
    },
  },
};
</script>

<style></style>
